var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2646 4.63574C12.3691 4.45505 12.6309 4.45505 12.7354 4.63574L15.5742 9.5459L15.6875 9.74219L15.9102 9.78613L20.7803 10.7471C20.9791 10.7863 21.0665 11.0214 20.9414 11.1807L17.6875 15.3037L17.5615 15.4639L17.583 15.666L18.1602 21.1992C18.1827 21.4166 17.9526 21.5696 17.7607 21.4648L12.7393 18.7236L12.5 18.5928L12.2607 18.7236L7.23926 21.4648C7.04713 21.5697 6.81578 21.4159 6.83887 21.1982L7.43359 15.5918L7.45605 15.3857L7.32617 15.2246L4.06055 11.1836C3.93239 11.0247 4.01941 10.7866 4.21973 10.7471L9.08984 9.78613L9.31152 9.74219L9.42578 9.5459L12.2646 4.63574Z",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutline);
export default __webpack_public_path__ + "static/media/star-outline.71415e211f3fc50c89bc06e0bb3b8035.svg";
export { ForwardRef as ReactComponent };